import { useCallback } from 'react'
import { useLazyQuery } from '@apollo/client'

import { GET_ARTISTS_BY_NAME } from '../graphql/queries'
import { IArtist } from 'shared/interfaces'

export const useSearchArtistByName = () => {
  const [getArtist, { data, loading, error }] = useLazyQuery<{ getArtistsByName: IArtist[] }, { name: string }>(GET_ARTISTS_BY_NAME)

  const getArtistByName = useCallback(
    async (artistName: string) => {
      const { data } = await getArtist({
        variables: {
          name: artistName
        }
      })

      return data?.getArtistsByName || []
    },
    [getArtist]
  )

  const hashArtistResult = (data?.getArtistsByName || []).reduce<Record<string, IArtist>>((res, a) => ({
    ...res,
    [a.id]: a,
  }), {})

  const getArtistResultById = (id: string) => hashArtistResult[id]

  return { getArtistByName, loading, error, data, getArtistResultById }
}
